<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFolder } from "@fortawesome/free-regular-svg-icons"

library.add(faFolder)

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

const data = ref()
const getData = async() => {
  await axios.get("./php/getCategoryList.php")
  .then((response) => {
    data.value = response.data
  })
}

onMounted(() => {
  getData()
})
</script>

<template>
  <h5>カテゴリ</h5>
  <div v-for="list in data" :key="list.id">
    <a :href="list.url">
      <font-awesome-icon icon="fa-regular fa-folder" size="lg" />
      {{ list.name }}&nbsp;({{ list.count }})
    </a>
  </div>
</template>

<style scoped>
  div {
    margin: .4em 0;
    text-align: start;
  }
</style>